import React from 'react';
import SafeIcon from './common/SafeIcon';
import { FiPlay, FiPause, FiRefreshCw } from 'react-icons/fi';

const GameControls = ({ isRunning, onToggle, onReset }) => {
  return (
    <div className="flex justify-center gap-2 md:gap-4">
      <button 
        onClick={onToggle}
        className="group relative px-4 md:px-6 py-2 md:py-3 rounded-xl bg-white/5 border border-white/10 text-white font-bold backdrop-blur-md transition-all hover:bg-white/10 hover:border-white/30 active:scale-95 overflow-hidden"
      >
        <div className="flex items-center gap-2">
          <SafeIcon icon={isRunning ? FiPause : FiPlay} className="text-sm md:text-lg text-cyan-400" />
          <span className="text-[11px] md:text-sm tracking-wide">{isRunning ? '暫停' : '繼續'}</span>
        </div>
      </button>

      <button 
        onClick={onReset}
        className="group relative px-4 md:px-6 py-2 md:py-3 rounded-xl bg-white/5 border border-white/10 text-white/60 font-bold backdrop-blur-md transition-all hover:bg-white/10 hover:text-white active:scale-95 overflow-hidden"
      >
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiRefreshCw} className="text-sm md:text-lg" />
          <span className="text-[11px] md:text-sm tracking-wide">重置</span>
        </div>
      </button>
    </div>
  );
};

export default GameControls;